import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // content
    sectionId='sustainability-impact-communities-intro'
    moduleName='intro-module'
    moduleVariation='A'
    disableBottomPadding={false}
    reverseContent={false}
    headingText={
      <>
        Taking action to improve lives, today <WidowBlock>and tomorrow</WidowBlock>
      </>
    }
    introContent={(
      <Typography
        align='left'
        disableBottomPadding>
        At Northwestern Mutual, we believe that when everyone can achieve their full potential, we all succeed. Through the Northwestern Mutual Foundation, we partner with nonprofits&#8212;alongside our employees and advisors nationwide&#8212;to strengthen their strategies, amplify their impact through philanthropy, and make a difference through hands&#45;on volunteering. Since the inception of the Northwestern Mutual Foundation in 1992, we have donated more than &#36;500 million to nonprofits.
      </Typography>
    )}
  />
);
